import { AfterViewInit, Component, ElementRef, HostListener, inject, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ProgressBarComponent } from '../../core/progress-bar/progress-bar.component';
import { MatSliderModule } from '@angular/material/slider';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../core/services/auth.service';
import { AuthUser } from '../../core/models/auth/auth.interface';
import { elementAt, Observable } from 'rxjs';
import { QuestionsService } from '../../core/services/questions.service';
import { TestsService } from '../../core/services/tests.service';
import { Test, TestRequest } from '../../core/models/test.model';
import { UsersService } from '../../core/services/users.service';
import Swal from 'sweetalert2';
import { User } from '../../core/models/user.interface';
import { DIMENSION_COLORS, QUESTION_STATUS, TEST_TYPES } from '../../core/shared/constants';
import { RangeComponent } from '../../core/shared/ui/range/range.component';
import { BaseComponent } from '../../core/shared/base.component';
import { LoaderService } from '../../core/shared/services/loader.service';
import { TutorialDialogComponent } from '../pages/tutorial-dialog/tutorial-dialog.component';
import { PolarChartComponent } from '../../core/shared/ui/polar-chart/polar-chart.component';
import { ConfigurationService } from '../../core/services/configuration.service';

// declare var anychart: any

@Component({
  selector: 'app-layout-assessment',
  standalone: true,
  imports: [ProgressBarComponent, MatSliderModule, CommonModule, RangeComponent, PolarChartComponent, TutorialDialogComponent],
  templateUrl: './layout-assessment.component.html',
  styleUrl: './layout-assessment.component.scss'
})
export class LayoutAssessmentComponent extends BaseComponent implements AfterViewInit {
  @ViewChild('progressBarEspaciado') progressBarEspaciado!: ElementRef;
  @ViewChild('contentChart') contentChart!: ElementRef;
  @ViewChild('chart') chartElement!: ElementRef;
  @ViewChild('questionTextContainer') questionTextContainer!: ElementRef;
  @ViewChild('calification') calification!: ElementRef;
  private authService: AuthService = inject(AuthService);
  private loader = inject(LoaderService);
  private configService = inject(ConfigurationService);
  authUser: AuthUser = this.authService.getAuthUser()!;
  // user: User = this.authService.getUser()!;
  user!: User;

  currentStep = 1;
  assessmentTypeId = 2;
  chart: any;
  series: number[] = [];
  dataSeries: any[] = [];
  currentQuestionIndex: number = 0;
  percentagem = 0;
  sliderValue: number = 50;
  currentValue: number = 0;
  dragging: boolean = false;
  questions: any[] = [];
  labels: string[] = [];
  isResponsive: boolean = false;
  test: Test | null = null;
  defaultAnswerValue = 5;
  isCompletingTest: boolean = false;

  currentQuestion: any;
  colors = DIMENSION_COLORS;
  isShowTutorial: boolean = false;
  tutorialSteps = [
    { title: 'Navegador', description: 'Lleva el control de tu progreso. En esta sección podrás ver el estado de tu recorrido y conocer en qué paso del proceso de autodescubrimiento te encuentras.' },
    { title: 'Círculo de vida', description: 'Realiza un análisis personal. Aquí podrás reflexionar sobre aspectos clave de tu vida y asignar una puntuación del 1 al 10 según tu nivel de satisfacción.' },
    { title: 'Dimensiones', description: 'Evalúa 8 áreas esenciales. Cada dimensión representa un aspecto importante de tu bienestar, dándote una visión completa para orientar tu desarrollo.' },
    { title: 'Calificación', description: 'Puntúa con precisión. Usa la barra de calificación para asignar fácilmente un valor a cada dimensión, visualizando tus prioridades y áreas de mejora.' },
  ]
  tutorialStep: number = 1;
  tutorialTitle!: string;
  tutorialDescription!: string;
  dialogPosition = { top: '0px', left: '0px' };
  dialogWidth = 350;
  dialogHeight = 280;

  // Variables para control de sonido del video
  videoIsMuted: boolean = true;
  currentVideoId: string | null = null;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkResponsive();
    if (this.isShowTutorial) {
      const dialogPosition = this.calculateDialogPosition(this.getElementToHighlight(this.tutorialStep), this.tutorialStep);
      this.dialogPosition = {
        top: dialogPosition.top,
        left: dialogPosition.left
      };
    }
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Verificar si la tecla presionada es Enter
    if (event.key === 'Enter') {
      // Prevenir el comportamiento por defecto
      event.preventDefault();
      
      // Solo ejecutar next() si el botón no está deshabilitado
      if (this.currentValue !== 0) {
        this.next();
      }
    }
  }

  constructor(private router: Router, private questionsService: QuestionsService,
    private testService: TestsService, private usersService: UsersService) {
    super()
  }
  ngAfterViewInit(): void {
    
  }

  async ngOnInit() {
    // this.chart = anychart.polar();
    await this.verifyNavigation();
    this.getTest();
    this.checkResponsive();
  }

  async verifyNavigation() {
    this.authService.findUserById(this.authUser.id).subscribe({
      next: (res: any) => {
        this.user = res.data;
        if (this.user && this.user.profile.onboardingComplete && this.user.profile.onboardingComplete === true) {
          this.router.navigate(['/dashboard']);
          return;
        }
        if (this.user && !this.user.profile.testNowComplete) {
          // Obtener video para el modal de assessment
          this.loader.show();
          this.configService.getEmbeddedVideos().subscribe({
            next: (response: any) => {
              this.loader.hide();
              if (response?.data && response.data.length > 0) {
                const videoData = response.data.find((video: any) => video.type === 'video_modal_analisis_del_presente');

                if (videoData && videoData.url) {
                  // Obtener el ID del video usando el método de la clase base
                  const videoId = this.extractYoutubeVideoId(videoData.url);
                  if (videoId) {
                    this.currentVideoId = videoId;
                    this.showVideoModal(videoId);
                  } else {
                    //this.showDefaultAssessmentModal();
                  }
                } else {
                  // Si no hay video, mostrar el modal con texto
                  //this.showDefaultAssessmentModal();
                }
              } else {
                // Si no hay videos configurados, mostrar el modal con texto
                //this.showDefaultAssessmentModal();
              }
            },
            error: (error: any) => {
              console.error('Error al obtener videos embebidos:', error);
              this.loader.hide();
              // En caso de error, mostrar el modal con texto
              //this.showDefaultAssessmentModal();
            }
          });
        }
      }
    });
  }

  /**
   * Helper para extraer el ID de un video de YouTube (utiliza el método de la clase base)
   */
  private extractYoutubeVideoId(url: string): string | null {
    // BaseComponent ya tiene este método, pero es privado, así que creamos un wrapper
    // para acceder a la funcionalidad sin duplicar código
    return this.getYoutubeVideoId(url);
  }

  /**
   * Muestra el modal de assessment por defecto (con texto)
   */
  private showDefaultAssessmentModal(): void {
    this.info(`<p style="font-size: 1rem; text-align: start;">Te invitamos a realizar un autodiagnóstico breve diseñado para evaluar tu satisfacción personal en ocho dimensiones claves de tu vida.<br><br>
      Lee cada pregunta y califica de forma general tu estado actual puntuando del 1 al 10 (donde 1 es "totalmente en desacuerdo" y 10 "totalmente de acuerdo").<br>
      Responde de manera sincera a fin de obtener una guía útil y coherente con tus expectativas.</p>`,
      "Análisis del presente",
      "Empezar ahora",
      false,
      `<a id="ver-tutorial-link" role="button" style="font-size: 14px; color: #000000; cursor: pointer;">Ver tutorial</a>`,
      this.changeShowTutorial.bind(this));
  }

  async getTest(): Promise<void> {
    this.loader.show();
    this.testService.find(this.authUser.id, TEST_TYPES.Hoy.id).subscribe({
      next: (res: any) => {
        this.loader.hide();
        if (res.data && res.data.length > 0 && res.data[0] && res.data[0].questions) {
          this.initialize(res.data[0].questions);
        } else {
          this.listQuestions();
        }
      },
      error: (err: any) => {
        console.log('err', err);
        this.loader.hide();
      }
    });
  }

  async listQuestions(): Promise<void> {
    this.loader.show();
    this.questionsService.find(this.assessmentTypeId).subscribe({
      next: (res: any) => {
        this.initialize(res.data);
        this.loader.hide();
      },
      error: (err: any) => {
        console.log('err', err);
        this.loader.hide();
      }
    });
  }

  private initialize(questions: any): void {
    // Validar que questions sea un array válido
    if (!questions || !Array.isArray(questions) || questions.length === 0) {
      console.warn('No se recibieron preguntas válidas para inicializar');
      return;
    }

    // Filtrar preguntas que tengan la estructura necesaria
    const validQuestions = questions.filter(q => 
      q && 
      q.dimension && 
      q.dimension.name && 
      q.answer && 
      typeof q.order === 'number'
    );

    if (validQuestions.length === 0) {
      console.warn('No se encontraron preguntas con estructura válida');
      return;
    }

    this.questions = validQuestions.sort((a: any, b: any) => a.order - b.order);
    
    // Limpiar arrays antes de llenarlos
    this.labels = [];
    this.series = [];
    
    this.questions.forEach(q => {
      this.labels.push(q.dimension.name);
      this.series.push(q.answer.value ? parseFloat(q.answer.value) : 0);
    });

    // Validar que se hayan agregado valores
    if (this.series.length === 0) {
      console.warn('No se pudieron procesar las series de datos');
      return;
    }

    this.currentValue = this.series[0];
    if (this.series[this.series.length - 1] > 0) {
      this.currentValue = this.series[this.series.length - 1];
      this.currentQuestionIndex = this.series.length - 1;
    }
    
    this.updateSingleDataPoint(this.currentQuestionIndex, this.currentValue);
  }

  updateTest(goTestFuture: boolean = false) {
    // Validar que existan las preguntas y el índice actual
    if (!this.questions || !this.questions[this.currentQuestionIndex]) {
      console.error('No hay preguntas disponibles o índice inválido para actualizar');
      return;
    }

    let test = {
      userId: this.authUser?.id ? this.authUser.id : "",
      userName: this.authUser?.name ? this.authUser.name : "",
      testTypeId: this.assessmentTypeId,
      question: {
        id: this.questions[this.currentQuestionIndex].id,
        title: this.questions[this.currentQuestionIndex].title,
        dimension: this.questions[this.currentQuestionIndex].dimension,
        status: QUESTION_STATUS.Contestado,
        answer: { value: this.currentValue.toString() }
      }
    };
    // this.loader.show();
    this.testService.updateTest(test).subscribe({
      next: async (res: any) => {
        // this.loader.hide();
      },
      error: (err: any) => {
        console.log('err', err);
        // this.loader.hide();
      }
    });
  }

  updateTestCompleted() {
    // Prevenir múltiples ejecuciones
    if (this.isCompletingTest) {
      return;
    }
    
    // Validar que existan las preguntas y el índice actual
    if (!this.questions || !this.questions[this.currentQuestionIndex]) {
      console.error('No hay preguntas disponibles o índice inválido para completar el test');
      this.isCompletingTest = false;
      return;
    }
    
    this.isCompletingTest = true;
    
    let test = {
      userId: this.authUser?.id ? this.authUser.id : "",
      userName: this.authUser?.name ? this.authUser.name : "",
      testTypeId: this.assessmentTypeId,
      question: {
        id: this.questions[this.currentQuestionIndex].id,
        title: this.questions[this.currentQuestionIndex].title,
        dimension: this.questions[this.currentQuestionIndex].dimension,
        status: QUESTION_STATUS.Contestado,
        answer: { value: this.currentValue.toString() }
      },
      completed: true
    };
    
    this.loader.show();
    this.testService.updateTest(test).subscribe({
      next: async (res: any) => {
        this.loader.hide();
        // Mostrar modal de confirmación antes de navegar
        this.showCompletionModal();
      },
      error: (err: any) => {
        console.log('err', err);
        this.loader.hide();
        this.isCompletingTest = false; // Resetear la bandera en caso de error
        // En caso de error, mostrar mensaje de error en lugar del modal de completado
        Swal.fire({
          title: 'Error',
          text: 'Ocurrió un error al guardar tus respuestas. Por favor, inténtalo de nuevo.',
          icon: 'error',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#ce0024'
        });
      }
    });
  }

  showCompletionModal() {
    Swal.fire({
      title: '',
      html: `
        <div style="text-align: center; padding: 0;">
          <!-- Imagen superior -->
          <div style="margin-bottom: 30px;">
            <img src="assets/img/office-meeting.jpg" 
                 alt="Completaste tu presente" 
                 style="width: 100%; height: 200px; object-fit: cover; border-radius: 15px 15px 0 0;" />
          </div>
          
          <!-- Título -->
          <h2 style="font-size: 28px; margin: 0 0 20px 0; color: #2c3e50; font-weight: 700; text-align: center;">
            ¡Completaste tu presente!
          </h2>
          
          <!-- Texto descriptivo -->
          <div style="padding: 0 20px 30px 20px;">
            <p style="font-size: 16px; color: #495057; line-height: 1.6; margin: 0; text-align: justify;">
              Ahora queremos que <strong>mires hacia tu futuro</strong> imagina cómo te gustaría vivir tu próxima etapa y qué necesitarás para llegar a esa etapa. Analiza qué aspectos de tu vida quieres transformar, qué te inspira a avanzar y cómo se ve esa versión futura de ti. Este es el momento de proyectarte y empezar a diseñar el futuro que deseas.
            </p>
          </div>
        </div>
      `,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Iniciar test futuro',
      cancelButtonText: 'Revisar respuestas',
      confirmButtonColor: '#ce0024',
      cancelButtonColor: 'transparent',
      reverseButtons: true,
      allowOutsideClick: false,
      customClass: {
        popup: 'completion-modal-popup',
        confirmButton: 'completion-modal-confirm-button',
        cancelButton: 'completion-modal-cancel-button',
        title: 'completion-modal-title',
        htmlContainer: 'completion-modal-html'
      },
      didOpen: () => {
        // Agregar estilos personalizados para el modal
        const style = document.createElement('style');
        style.innerHTML = `
          .completion-modal-popup {
            border-radius: 20px !important;
            width: 90% !important;
            max-width: 550px !important;
            min-width: 300px !important;
            box-shadow: 0 10px 30px rgba(0,0,0,0.15) !important;
            border: 1px solid #e9ecef !important;
            margin: 20px !important;
          }
          
          .completion-modal-title {
            padding: 0 !important;
            margin-bottom: 20px !important;
          }
          
          .completion-modal-html {
            margin: 0 !important;
          }
          
          .completion-modal-confirm-button {
            border-radius: 10px !important;
            min-width: 140px !important;
            font-weight: 600 !important;
            font-size: 16px !important;
            padding: 12px 30px !important;
            box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3) !important;
            background: linear-gradient(135deg, #dc3545 0%, #c82333 100%) !important;
            border: none !important;
            transition: all 0.3s ease !important;
            width: 45% !important;
          }
          
          .completion-modal-confirm-button:hover {
            transform: translateY(-2px) !important;
            box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4) !important;
          }
          
          .completion-modal-cancel-button {
            border-radius: 10px !important;
            min-width: 140px !important;
            font-weight: 600 !important;
            font-size: 16px !important;
            padding: 12px 30px !important;
            background: #fff !important;
            color: #dc3545 !important;
            border: 2px solid #E0E4EA !important;
            transition: all 0.3s ease !important;
            width: 45% !important;
          }
          
          .completion-modal-cancel-button:hover {
            background: #dc3545 !important;
            border: 2px solid #dc3545 !important;
            color: #fff !important;
            transform: translateY(-2px) !important;
            box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3) !important;
          }
          
          .swal2-actions {
            gap: 15px !important;
            margin-top: 25px !important;
            padding: 0 20px 20px 20px !important;
            flex-wrap: wrap !important;
            justify-content: center !important;
          }
          
          /* Responsive para tablets */
          @media (max-width: 768px) {
            .completion-modal-popup {
              width: 95% !important;
              max-width: 400px !important;
              margin: 15px !important;
              border-radius: 15px !important;
            }
            
            .completion-modal-confirm-button,
            .completion-modal-cancel-button {
              min-width: 120px !important;
              font-size: 15px !important;
              padding: 11px 25px !important;
              width: 100% !important;
            }
            
            .swal2-actions {
              gap: 12px !important;
              padding: 0 15px 15px 15px !important;
              flex-direction: column-reverse !important;
            }
          }
          
          /* Responsive para móviles */
          @media (max-width: 480px) {
            .completion-modal-popup {
              width: 95% !important;
              max-width: 320px !important;
              margin: 10px !important;
              border-radius: 12px !important;
            }
            
            .completion-modal-confirm-button,
            .completion-modal-cancel-button {
              width: 100% !important;
              min-width: unset !important;
              font-size: 14px !important;
              padding: 12px 20px !important;
              margin: 0 !important;
              width: 100% !important;
            }
            
            .swal2-actions {
              flex-direction: column !important;
              gap: 10px !important;
              padding: 0 15px 15px 15px !important;
              flex-direction: column-reverse !important;
            }
            
            /* Ajustar imagen en móviles */
            .completion-modal-popup img {
              height: 150px !important;
              border-radius: 12px 12px 0 0 !important;
              display: none;
            }
            
            /* Ajustar texto en móviles */
            .completion-modal-popup h2 {
              font-size: 24px !important;
              margin: 0 0 15px 0 !important;
              padding: 0 10px !important;
            }
            
            .completion-modal-popup p {
              font-size: 14px !important;
              padding: 0 15px 20px 15px !important;
            }
          }
          
          /* Responsive para pantallas muy pequeñas */
          @media (max-width: 360px) {
            .completion-modal-popup {
              width: 98% !important;
              margin: 5px !important;
            }
            
            .completion-modal-popup h2 {
              font-size: 22px !important;
            }
            
            .completion-modal-popup p {
              font-size: 13px !important;
            }
          }
        `;
        document.head.appendChild(style);
      }
    }).then((result) => {
      // Resetear la bandera independientemente de la acción
      this.isCompletingTest = false;
      
      if (result.isConfirmed) {
        // Botón "Continuar" - navegar al assessment-future
        this.router.navigate(['/assessment-future']);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // Botón "Revisar respuestas" - volver a la primera pregunta
        if (this.questions && this.questions.length > 0 && this.questions[0]) {
          this.currentQuestionIndex = 0;
          this.currentValue = this.questions[0].answer.value ?? 0;
          this.actualizarPorcentaje();
        } else {
          console.error('No hay preguntas disponibles para revisar');
        }
      }
    });
  }

  private checkResponsive() {
    this.isResponsive = window.innerWidth <= 768;
  }

  next() {
    // Validar que existan las preguntas y el índice actual
    if (!this.questions || !this.questions[this.currentQuestionIndex]) {
      console.error('No hay preguntas disponibles o índice inválido');
      return;
    }

    if (this.currentValue == 0) {
      this.alert("Debe contestar la pregunta con un valores entre 1-10", "");
      return;
    }
    
    // Actualizar la pregunta actual
    this.updateSingleDataPoint(this.currentQuestionIndex, this.currentValue);
    this.questions[this.currentQuestionIndex].answer.value = this.currentValue;
    
    if (this.currentQuestionIndex < this.questions.length - 1) {
      // Ir a la siguiente pregunta
      this.currentQuestionIndex++;
      this.currentValue = this.questions[this.currentQuestionIndex].answer.value ?? 0;
      this.actualizarPorcentaje();
      this.updateTest();
    } else {
      // Es la última pregunta, completar el test y navegar al futuro
      this.updateTestCompleted();
    }
  }

  async beginTestFuturo() {
    // Validar que existan las preguntas y el índice actual
    if (!this.questions || !this.questions[this.currentQuestionIndex]) {
      console.error('No hay preguntas disponibles o índice inválido');
      return;
    }

    if (this.currentValue == 0) {
      this.alert("Debe contestar la pregunta con un valores entre 1-10", "");
      return;
    }
    this.updateTest();
    this.router.navigate(['/assessment-future']);
  }

  previous() {
    // Validar que existan las preguntas y el índice actual
    if (!this.questions || !this.questions[this.currentQuestionIndex]) {
      console.error('No hay preguntas disponibles o índice inválido');
      return;
    }

    if (this.currentQuestionIndex > 0) {
      this.currentQuestionIndex--;
      this.currentValue = this.questions[this.currentQuestionIndex].answer.value ?? 0;
      this.updateSingleDataPoint(this.currentQuestionIndex, this.currentValue);
    }
  }

  isLastQuestion(): boolean {
    // Validar que existan las preguntas
    if (!this.questions || this.questions.length === 0) {
      return false;
    }
    
    return this.currentQuestionIndex === this.questions.length - 1;
  }

  actualizarPorcentaje() {
    // Validar que existan las preguntas
    if (!this.questions || this.questions.length === 0) {
      this.percentagem = 0;
      return;
    }
    
    this.percentagem = Math.floor((this.currentQuestionIndex / (this.questions.length - 1)) * 100);
  }

  refreshDataSeries() {
    // Validar que existan los arrays necesarios
    if (!this.series || !this.labels || !this.colors) {
      console.error('No se pueden refrescar las series de datos: arrays no disponibles');
      this.dataSeries = [];
      return;
    }
    
    this.dataSeries = [];
    for (let i = 0; i < this.series.length; i++) {
      // Validar que el índice sea válido para labels y colors
      if (this.labels[i] && this.colors[i]) {
        this.dataSeries.push({ x: this.labels[i], value: this.series[i], fill: this.colors[i] });
      }
    }
  }

  updateSingleDataPoint(index: number, newValue: number) {
    // Validar que el índice sea válido y que existan las series
    if (index < 0 || !this.series || index >= this.series.length) {
      console.error('Índice inválido para actualizar el punto de datos');
      return;
    }
    
    this.series[index] = newValue;
    this.refreshDataSeries();
  }

  changeRange(value: any) {
    // Validar que existan las preguntas y el índice actual
    if (!this.questions || !this.questions[this.currentQuestionIndex]) {
      console.error('No hay preguntas disponibles o índice inválido');
      return;
    }

    this.currentValue = value;
    this.updateSingleDataPoint(this.currentQuestionIndex, this.currentValue);
    this.updateTest();
  }

  changeShowTutorial() {
    this.tutorialStep = 1;
    this.updateTutorialContent();
    this.isShowTutorial = !this.isShowTutorial;
    if (this.isShowTutorial === false) this.clearPreviousFocus();
  }

  resetTutorial() {
    this.tutorialStep = 1;
    this.updateTutorialContent();
  }

  nextStepTutorial() {
    if (this.tutorialStep < this.tutorialSteps.length) {
      this.tutorialStep++;
      this.updateTutorialContent();
    } else {
      this.clearPreviousFocus();
      this.isShowTutorial = false;
    }
  }

  private updateTutorialContent() {
    this.tutorialTitle = this.tutorialSteps[this.tutorialStep - 1].title;
    this.tutorialDescription = this.tutorialSteps[this.tutorialStep - 1].description;
    
    const targetElement = this.getElementToHighlight(this.tutorialStep);
    if (targetElement && targetElement.nativeElement) {
      this.showTutorialDialog(targetElement);
    } else {
      console.warn('No se pudo encontrar el elemento para el tutorial step:', this.tutorialStep);
    }
  }

  getElementToHighlight(option: number): ElementRef {
    switch (option) {
      case 1:
        return this.progressBarEspaciado || this.contentChart;
      case 2:
        return this.contentChart || this.progressBarEspaciado;
      case 3:
        return this.questionTextContainer || this.contentChart;
      case 4:
        return this.calification || this.contentChart;
      default:
        return this.contentChart || this.progressBarEspaciado;
    }
  }

  showTutorialDialog(targetElement: ElementRef) {
    // Validar que el elemento existe antes de usarlo
    if (!targetElement || !targetElement.nativeElement) {
      console.warn('Elemento del tutorial no encontrado:', targetElement);
      return;
    }

    targetElement.nativeElement.scrollIntoView({
      behavior: 'smooth', // Desplazamiento suave
      block: 'center',    // Centra el elemento en la ventana
      inline: 'center'    // En caso de ser horizontal, lo centra también
    });

    const dialogPosition = this.calculateDialogPosition(targetElement, this.tutorialStep);
    this.dialogPosition = {
      top: dialogPosition.top,
      left: dialogPosition.left
    };
    this.clearPreviousFocus();
    targetElement.nativeElement.classList.add('tutorial-focus');
  }

  clearPreviousFocus() {
    document.querySelectorAll('.tutorial-focus').forEach((element) => {
      element.classList.remove('tutorial-focus');
    });
  }

  private calculateDialogPosition(targetElement: ElementRef, stepNumber: number): { top: string; left: string } {
    if (!targetElement || !targetElement.nativeElement) {
      return { top: '50px', left: '50px' };
    }
    
    const elementRect = targetElement.nativeElement.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    const targetCenterX = elementRect.left + elementRect.width / 2;
    const targetCenterY = elementRect.top + elementRect.height / 2;
    const centerX = viewportWidth / 2;
    const centerY = viewportHeight / 2;

    let dialogLeft, dialogTop;
    const padding = 20;
    if (stepNumber > 2) {
      dialogLeft = elementRect.left + (elementRect.width - this.dialogWidth) / 2;
      dialogTop = elementRect.top - this.dialogHeight - padding;
    } else {
      dialogLeft = (targetCenterX + centerX) / 2 - this.dialogWidth / 2;
      dialogTop = (targetCenterY + centerY) / 2 - this.dialogHeight / 2;
    }

    const overlapThreshold = this.dialogHeight / 2; // Adjust this as needed
    if (dialogTop + this.dialogHeight > elementRect.top + overlapThreshold) {
      dialogTop = elementRect.top + elementRect.height + padding; // Position below the element
    }


    const left = Math.min(Math.max(dialogLeft, 0), viewportWidth - this.dialogWidth);
    const top = Math.min(Math.max(dialogTop, 0), viewportHeight - this.dialogHeight);

    return {
      top: `${top}px`,
      left: `${left}px`
    };
  }

  splitQuestions(questionText: string): string[] {
    if (!questionText) return [];
    // Divide el texto en preguntas individuales
    return questionText.split('¿')
      .map(q => q.trim())
      .filter(q => q.length > 0)
      .map(q => `¿${q}${q.endsWith('?') ? '' : '?'}`);
  }

  /**
   * Muestra el modal con el video y controles de sonido
   */
  showVideoModal(videoId: string): void {
    // Crear estilos para el video y el botón de sonido
    const styles = `
      <style>
        .results-video-container {
          width: 100%;
          display: flex;
          justify-content: center;
        }
        .results-video-wrapper {
          width: 350px;
          height: 350px;
          position: relative;
          overflow: hidden;
          background-color: black;
          border-radius: 0;
        }
        .results-video-iframe {
          position: absolute;
          top: 0%;
          left: 50%;
          width: 100%;
          height: 100%;
          transform: translateX(-50%);
          border: none;
          pointer-events: none;
          object-fit: cover;
        }
        .sound-toggle-btn {
          position: absolute;
          bottom: 55px;
          right: 10px;
          background-color: rgba(0, 0, 0, 0.7);
          color: white;
          border: none;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 100;
          transition: all 0.2s ease;
        }
        .sound-toggle-btn:hover {
          background-color: rgba(0, 0, 0, 0.9);
          transform: scale(1.1);
        }
        .fullscreen-btn {
          position: absolute;
          bottom: 10px;
          right: 10px;
          background: rgba(0,0,0,0.6);
          border: none;
          border-radius: 50%;
          padding: 8px;
          cursor: pointer;
        }
      </style>
    `;

    // Crear URL del video con el parámetro mute
    const videoSrc = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&mute=1&controls=0&loop=1&playlist=${videoId}&rel=0&showinfo=0&modestbranding=1&disablekb=1&fs=0&iv_load_policy=3&cc_load_policy=0&enablejsapi=0&origin=${window.location.origin}&hl=en&cc=0&playsinline=1&autohide=1&color=white&start=1&theme=dark&vq=hd1080&showsearch=0&ecver=2&playerapiid=ytplayer&wmode=transparent&annotation=0`;

    // Crear HTML del video con botón de sonido
    const videoHtml = `
      ${styles}
      <div class="results-video-container">
        <div class="results-video-wrapper">
          <iframe 
            id="modal-video-frame"
            class="results-video-iframe"
            src="${videoSrc}" 
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowfullscreen>
          </iframe>
          <button 
            id="video-sound-toggle" 
            class="sound-toggle-btn" 
            title="Activar sonido">
            <!-- Icono de silencio -->
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path d="M3,9v6h4l5,5V4L7,9H3z" fill="white"/>
              <path d="M16.5,12c0-1.77-1.02-3.29-2.5-4.03v8.05C15.48,15.29,16.5,13.77,16.5,12z M14,3.23v2.06 c2.89,0.86,5,3.54,5,6.71s-2.11,5.85-5,6.71v2.06c4.01-0.91,7-4.49,7-8.77S18.01,4.14,14,3.23z" fill="white" opacity="0.5"/>
              <line x1="23" y1="3" x2="3" y2="21" stroke="white" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
          <button id="video-fullscreen-toggle" class="fullscreen-btn" title="Pantalla completa">
            <!-- Icono pantalla completa -->
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="white">
              <path d="M7 14H5v5h5v-2H7v-3zm0-4h2V7h3V5H7v5zm10 4h2v3h-3v2h5v-5h-4zm-3-9v2h3v3h2V5h-5z"/>
            </svg>
          </button>
        </div>
      </div>
    `;

    // Mostrar el modal con video
    // this.info(videoHtml,
    //   "Análisis del presente",
    //   "Empezar ahora",
    //   false,
    //   `<a id="ver-tutorial-link" role="button" style="font-size: 14px; color: #000000; cursor: pointer;">Ver tutorial</a>`,
    //   this.changeShowTutorial.bind(this));

    // Agregar el evento al botón de sonido después de que el modal se haya mostrado
    // setTimeout(() => {
    //   const soundToggleBtn = document.getElementById('video-sound-toggle');
    //   if (soundToggleBtn) {
    //     soundToggleBtn.addEventListener('click', () => this.toggleVideoSound());
    //   }
    //   const fullscreenToggleBtn = document.getElementById('video-fullscreen-toggle');
    //   if (fullscreenToggleBtn) {
    //     fullscreenToggleBtn.addEventListener('click', () => this.toggleVideoFulscreen());
    //   }
    // }, 100);
  }

  /**
   * Activa o desactiva el sonido del video
   */
  toggleVideoSound(): void {
    this.videoIsMuted = !this.videoIsMuted;

    if (!this.currentVideoId) return;

    const videoFrame = document.getElementById('modal-video-frame') as HTMLIFrameElement;
    const soundToggleBtn = document.getElementById('video-sound-toggle');

    if (videoFrame) {
      // Crear nueva URL con el parámetro mute actualizado
      const newSrc = `https://www.youtube-nocookie.com/embed/${this.currentVideoId}?autoplay=1&mute=${this.videoIsMuted ? '1' : '0'}&controls=0&loop=1&playlist=${this.currentVideoId}&rel=0&showinfo=0&modestbranding=1&disablekb=1&fs=0&iv_load_policy=3&cc_load_policy=0&enablejsapi=0&origin=${window.location.origin}&hl=en&cc=0&playsinline=1&autohide=1&color=white&start=1&theme=dark&vq=hd1080&showsearch=0&ecver=2&playerapiid=ytplayer&wmode=transparent&annotation=0`;

      // Actualizar el iframe con la nueva URL
      videoFrame.src = newSrc;
    }

    // Actualizar el botón con el icono correspondiente
    if (soundToggleBtn) {
      soundToggleBtn.innerHTML = this.videoIsMuted ?
        // Icono de silencio
        `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M3,9v6h4l5,5V4L7,9H3z" fill="white"/>
          <path d="M16.5,12c0-1.77-1.02-3.29-2.5-4.03v8.05C15.48,15.29,16.5,13.77,16.5,12z M14,3.23v2.06 c2.89,0.86,5,3.54,5,6.71s-2.11,5.85-5,6.71v2.06c4.01-0.91,7-4.49,7-8.77S18.01,4.14,14,3.23z" fill="white" opacity="0.5"/>
          <line x1="23" y1="3" x2="3" y2="21" stroke="white" stroke-width="2" stroke-linecap="round"/>
        </svg>` :
        // Icono de sonido activo
        `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M3,9v6h4l5,5V4L7,9H3z" fill="white"/>
          <path d="M16.5,12c0-1.77-1.02-3.29-2.5-4.03v8.05C15.48,15.29,16.5,13.77,16.5,12z M14,3.23v2.06 c2.89,0.86,5,3.54,5,6.71s-2.11,5.85-5,6.71v2.06c4.01-0.91,7-4.49,7-8.77S18.01,4.14,14,3.23z" fill="white"/>
        </svg>`;

      soundToggleBtn.setAttribute('title', this.videoIsMuted ? 'Activar sonido' : 'Silenciar');
    }
  }

  toggleVideoFulscreen(): void {
    const videoFrame = document.getElementById('modal-video-frame') as HTMLIFrameElement;
    const wrapper = videoFrame?.parentElement;

    if (document.fullscreenElement) {
      document.exitFullscreen();
      return;
    }
    if (wrapper?.requestFullscreen) {
      wrapper.requestFullscreen();
    } else if ((wrapper as any).webkitRequestFullscreen) {
      (wrapper as any).webkitRequestFullscreen();
    } else if ((wrapper as any).mozRequestFullScreen) {
      (wrapper as any).mozRequestFullScreen();
    } else if ((wrapper as any).msRequestFullscreen) {
      (wrapper as any).msRequestFullscreen();
    } else {
      console.warn('Fullscreen API no soportada');
    }
  }
}
